import config from '../config';
import selectedEnvironment from '../env';

const API_CaseRelationship_URL = `${config[selectedEnvironment].API_URL}/CaseRelationship`;

// Case Relationship Service
const CreateCaseRelationship = async (token, caseRelationshipData) => {
    try {
        const response = await fetch(`${API_CaseRelationship_URL}/CreateCaseRelationship`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(caseRelationshipData)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
        console.error('Error creating case relationship:', error);
        throw error;
    }
};

const UpdateCaseRelationship = async (token, caseRelationshipData) => {
    try {
        const response = await fetch(`${API_CaseRelationship_URL}/UpdateCaseRelationship`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(caseRelationshipData)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
        console.error('Error updating case relationship:', error);
        throw error;
    }
};

const DeleteCaseRelationship = async (token, relationshipId) => {
    try {
        const response = await fetch(`${API_CaseRelationship_URL}/DeleteCaseRelationship/${relationshipId}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
        console.error('Error deleting case relationship:', error);
        throw error;
    }
};

const GetCaseRelationshipsByCaseId = async (token, caseId) => {
    try {
        const response = await fetch(`${API_CaseRelationship_URL}/GetCaseRelationshipsByCaseId/${caseId}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error getting case relationships:', error);
        return null;
    }
};

const GetCaseRelationshipById = async (token, id) => {
    try {
        const response = await fetch(`${API_CaseRelationship_URL}/GetCaseRelationshipById/${id}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error getting case relationship by ID:', error);
        return null;
    }
};

const GetSubordinateCaseIds = async (token, mainCaseId) => {
    try {
        const response = await fetch(`${API_CaseRelationship_URL}/GetSubordinateCaseIds/${mainCaseId}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error getting subordinate case IDs:', error);
        return [];
    }
};

const GetMainCaseIdForSubordinate = async (token, subordinateCaseId) => {
    try {
        const response = await fetch(`${API_CaseRelationship_URL}/GetMainCaseIdForSubordinate/${subordinateCaseId}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data.mainCaseId;
    } catch (error) {
        console.error('Error getting main case ID for subordinate:', error);
        return null;
    }
};

const CaseRelationshipService = {
    CreateCaseRelationship,
    UpdateCaseRelationship,
    DeleteCaseRelationship,
    GetCaseRelationshipsByCaseId,
    GetCaseRelationshipById,
    GetSubordinateCaseIds,
    GetMainCaseIdForSubordinate,
};

export default CaseRelationshipService;
